import http from "./http";

const apiEndpoint = process.env.REACT_APP_BASE_URL + "/api/AddDiscType";

export function getAddDiscList(type, addId) {
  return http.post(`${apiEndpoint}/GetDropDown/?type=${type}&addId=${addId}`);
}
